import { Link } from "react-router-dom";
import { useReveal } from "@/hooks/useReveal";

export const CTASection = ({
  title = "Klar til at vækste?",
  text = "Lad os tage en uforpligtende snak om hvordan vi kan hjælpe din virksomhed med synlighed, content og vækst.",
  primaryLabel = "Få en gratis analyse",
  primaryTo = "/kontakt",
}) => {
  const refTitle = useReveal();
  const refText = useReveal();
  const refBtn = useReveal();

  return (
    <section className="pt-6 pb-16 lg:pt-10 lg:pb-20 relative">
      <div className="mx-auto max-w-5xl px-5 lg:px-10 text-center">
        <h2
          ref={refTitle}
          className="reveal font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05]"
        >
          {title}
        </h2>
        <p
          ref={refText}
          className="reveal mt-5 text-white/65 text-base sm:text-lg max-w-2xl mx-auto"
          style={{ transitionDelay: "120ms" }}
        >
          {text}
        </p>
        <div
          ref={refBtn}
          className="reveal mt-8 flex flex-col sm:flex-row gap-3 justify-center"
          style={{ transitionDelay: "240ms" }}
        >
          <Link
            to={primaryTo}
            className="btn-pop inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[hsl(var(--accent))] text-[hsl(var(--accent-ink))] font-semibold hover:shadow-[0_12px_40px_-8px_hsla(75,100%,67%,0.7)] hover:scale-[1.02] transition-transform"
          >
            {primaryLabel}
            <span aria-hidden className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
          <Link
            to="/cases"
            className="btn-pop inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-white/15 text-white/90 hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))]"
          >
            Se vores cases
          </Link>
        </div>
      </div>
    </section>
  );
};
